var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg06(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.22 126.68"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 0v20.22h-2.37q-16.67.26-26.81 8.67T25.15 52.25q9.85-10 24.89-10 16.14 0 25.66 11.55t9.52 30.4A45.58 45.58 0 0180 106a37.39 37.39 0 01-14.78 15.21 43 43 0 01-21.63 5.44Q24 126.68 12 113.08T0 76.8V68q0-20.17 7.6-35.59A55.77 55.77 0 0129.44 8.54Q43.68.08 62.45 0zM42.57 62a19.54 19.54 0 00-10.79 3.1 18.64 18.64 0 00-7.14 8.18v7.46q0 12.3 4.84 19.21a15.65 15.65 0 0013.6 6.91 15.49 15.49 0 0012.78-6.23q4.89-6.24 4.89-16.16 0-10.08-4.93-16.28A16.08 16.08 0 0042.57 62z",
    fill: "#fff"
  })));
}
Svg06.displayName = '06';
export default Svg06;